import React, { useState, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import axiosInstance from '../axiosInstance';
import './AdminApp.css'; 
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'remixicon/fonts/remixicon.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';

import Header from './Components/Header';
import SideBar from './Components/SideBar';
import AdminDashboard from './Components/AdminDashboard';
import Main from './Components/Main';
import RegisterDeliverable from './Components/RegisterDeliverable';
import ContactsBanner from './Components/ContactsBanner'; 
import BlockUser from './Components/BlockUser.jsx'; 
import SAT from './Components/SAT.jsx'; 
import Feedback from './Components/Feedback.jsx'; 
import SupportServices from './Components/SupportServices.jsx'; 
import DatabaseViewer from './Components/DatabaseViewer.jsx';

const API_URL = process.env.REACT_APP_API_URL;

function AdminApp() {
  const [pageTitle, setPageTitle] = useState('Dashboard');
  const [pageIcon, setPageIcon] = useState('bi bi-grid');
  const [currentView, setCurrentView] = useState('Dashboard');
  const [showDeliverable, setShowDeliverable] = useState(false); 
  const [showContacts, setShowContacts] = useState(false);
  const [showBlockUser, setShowBlockUser] = useState(false); 
  const [showSAT, setShowSAT] = useState(false); 
  const [showFeedback, setShowFeedback] = useState(false); 
  const [showSupportServices, setShowSupportServices] = useState(false); 
  const [collapsed, setCollapsed] = useState(true);
  const [feedbackId, setFeedbackId] = useState(null); 
  const [feedbackCount, setFeedbackCount] = useState(0);
  const [feedbackSummary, setFeedbackSummary] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [showDatabaseViewer, setShowDatabaseViewer] = useState(false);



  const [showText, setShowText] = useState(window.innerWidth > 920);





  const handleNavClick = (view) => {
    
    if (view === 'Deliverable') {
      setShowDeliverable(true);
      setShowContacts(false);
      setShowBlockUser(false);
      setShowSAT(false);
      setShowFeedback(false);
      setShowSupportServices(false);
    } else if (view === 'Contacts') {
      setShowContacts(true);
      setShowDeliverable(false);
      setShowBlockUser(false);
      setShowSAT(false);
      setShowFeedback(false);
      setShowSupportServices(false);
    } else if (view === 'Block User') {
      setShowBlockUser(true);
      setShowDeliverable(false);
      setShowContacts(false);
      setShowSAT(false);
      setShowFeedback(false);
      setShowSupportServices(false);
    } else if (view === 'Upload Quiz') {
      setShowSAT(true);
      setShowBlockUser(false);
      setShowDeliverable(false);
      setShowContacts(false);
      setShowFeedback(false);
      setShowSupportServices(false);
    } else if (view === 'Feedback') {
      if (feedbackSummary?.messages?.length > 0) {
        setSelectedMessage(feedbackSummary.messages[0]);
      }
     
      setShowFeedback(true);
      setShowSAT(false);
      setShowBlockUser(false);
      setShowDeliverable(false);
      setShowContacts(false);
      setShowSupportServices(false);
    } else if (view === 'Support Services') { 
      setShowSupportServices(true);
      setShowFeedback(false);
      setShowSAT(false);
      setShowBlockUser(false);
      setShowDeliverable(false);
      setShowContacts(false);
      } else if (view === 'Database') {
      setShowDatabaseViewer(true);
      setShowDeliverable(false);
      setShowContacts(false);
      setShowBlockUser(false);
      setShowSAT(false);
      setShowFeedback(false);
      setShowSupportServices(false);
    } else {
      setCurrentView(view);
      setShowDeliverable(false);
      setShowContacts(false);
      setShowBlockUser(false);
      setShowSAT(false);
      setShowFeedback(false);
      setShowSupportServices(false);
    }
  };

  const handleCloseSupportServices = () => {
    setShowSupportServices(false); 
  };

  const handleCloseRegister = () => {
    setShowDeliverable(false); 
  };

  const handleCloseContacts = () => {
    setShowContacts(false); 
  };
  const handleCloseBlockUser = () => {
    setShowBlockUser(false);
  };

  const handleCloseSAT = () => {
    setShowSAT(false); 
  };
  const handleCloseFeedback = () => {
    setShowFeedback(false);
  };
  const filterCondition = (navItem) => {
    return navItem._id >= 1 && navItem._id <= 99; 
  };
  const handleToggleSidebar = () => {
    setCollapsed(prevState => !prevState);
  };

  const handleCloseDatabaseViewer = () => {
    setShowDatabaseViewer(false);
  };
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 920) {
        setCollapsed(true); 
      } else {
        setCollapsed(false);  
      }
      setShowText(window.innerWidth > 920); 
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resi   ze', handleResize);
  }, []);

  const handleSelectFeedback = (id) => {
    setFeedbackId(id); // Set the ID of the selected feedback
  };
      
  useEffect(() => {
    const checkFeedback = async () => {
      try {
        const res = await axiosInstance.get(`${API_URL}/api/deliverable/feedback-count`);
        console.log("Response:", res.data);
  
        // Set count
        const newCount = res.data.count || 0;
        setFeedbackCount(newCount);
        console.log("Set count to:", newCount);
  
        // Set feedback summary
        setFeedbackSummary(res.data);
        console.log("Set summary to:", res.data);
  
      } catch (error) {
        console.error("Error:", error);
      }
    };
  
    checkFeedback();
  }, []);
      
      

      
      

  return (
    <div className="admin-container">
      <Header className="header" />
      
      <div className={`sidebar ${collapsed ? 'collapsed' : 'expanded'}`}>
        <SideBar
          filterCondition={filterCondition} 
          onNavClick={handleNavClick}
          collapsed={collapsed}
          onToggleSidebar={handleToggleSidebar}
          feedbackCount={feedbackCount}
          setFeedbackCount={setFeedbackCount}
          feedbackSummary={feedbackSummary}
          
          feedbackId={feedbackId}
          setFeedbackId={setFeedbackId}  
          setSelectedMessage={setSelectedMessage}
          />
          
      </div>

      <div className={`admin-content-container ${collapsed ? 'collapsed' : 'expanded'}`}>
        <Main pageTitle={pageTitle} pageIcon={pageIcon} />
        {showDeliverable && <RegisterDeliverable onClose={handleCloseRegister} />}
        {showContacts && <ContactsBanner onClose={handleCloseContacts} />}
        {showBlockUser && <BlockUser onClose={handleCloseBlockUser} />} 
        {showSAT && <SAT onClose={handleCloseSAT} />}

        {showFeedback && <Feedback
         onClose={handleCloseFeedback}
         feedbackSummary={feedbackSummary}
         setFeedbackSummary={setFeedbackSummary} 
         feedbackId={feedbackId}
         setFeedbackId={setFeedbackId}  
         setSelectedMessage={setSelectedMessage}

         />}

        {showSupportServices && <SupportServices onClose={handleCloseSupportServices} />}
        {!showDeliverable && !showContacts && !showBlockUser && !showSupportServices && !showSAT && !showFeedback && (
          <Routes>
            <Route exact path="/admin" element={<AdminDashboard />} />
          </Routes>
        )}
        {showDatabaseViewer && (
          <div className="modal-view-container">
            <div className="database-viewer-wrapper">
              <DatabaseViewer onClose={handleCloseDatabaseViewer} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminApp;
